module.exports = __webpack_public_path__ + "static/media/import.5c0caddf.svg";